import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Row, Col } from 'react-flexbox-grid';
import { Section, Image, SectionHeader, Heading, Button } from 'components';
import './Banner.scss';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        teamImage: file(
          relativePath: { eq: "office/people-meet-in-kitchen.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 663) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section additionalClass={'connect-page__banner'} side={'right'}>
        <Row className={'no-gap connect-page__banner-row'}>
          <Col sm={12} md={6}>
            <SectionHeader
              size={'extra-large'}
              color={'mine-shaft'}
              lineColor={'violet'}
              descriptionColor={'black'}
              buttonColor={'black'}
              fixed
              additionalClass={'section-header__description--medium'}
            >
              Connect
              <br />
              with Our Circle
            </SectionHeader>
            <Heading
              type={2}
              size={'medium'}
              color={'white'}
              additionalClass={'connect-page__banner-lead'}
            >
              We are digital thinkers who build products for you. We draw our
              strength from self-development, exchanging ideas and giving back
              to the community. Experience our culture and get to know our
              people.
              <br />
              <br />
              Pick a place where you feel comfortable or just contact one of
              our Customer Success Guides straight away.
            </Heading>
            <Button
              onClick={() => {
                window.location.replace('#form');
                history.replaceState(
                  '',
                  document.title,
                  `${window.location.pathname}#form`,
                );
              }}
              color={'black'}
              id={'contact-now-shortcut'}
              transparent
            >
              Contact now
            </Button>
          </Col>
          <Col sm={12} md={6} className={'connect-page__banner-image'}>
            <Image
              src={data.teamImage.childImageSharp.fluid}
              alt={'People talking'}
              style={{
                objectPosition: 'top center',
              }}
            />
          </Col>
        </Row>
      </Section>
    )}
  />
);

export default Banner;
